import { useEffect } from 'react';

const ThemeColor = (isMenuOpen) => {

    useEffect(() => {
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');

        // store original color to restore
        const originalThemeColor = metaThemeColor?.getAttribute('content');

        // set new theme color
        if (metaThemeColor && isMenuOpen) {
          metaThemeColor.setAttribute('content', '#1E293B');
        }

        // clean-up to restore original color
        return () => {
          if (metaThemeColor && originalThemeColor) {
            metaThemeColor.setAttribute('content', originalThemeColor);
          }
        };
      }, [isMenuOpen]); // empty dependency array ensures this runs once on mount and cleans up on unmount

};

export default ThemeColor;